<template>
  <!--
    	描述：组件-选择题库
    -->
  <el-dialog title="选择题库" width="1000px" style="height:750px" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="content">
      <!--分类-->
      <div class="p-10-0 blue">
        <span class="p10" v-if="formSearch.type != 60">筛选分类</span>
        <el-select v-model="formSearch.type" clearable placeholder="请选择类型" @change="changeType" style="width:120px" v-if="formSearch.type != 60">
          <el-option :label="item.name" :value="item.key_name" v-for="(item, index) in typeData" :key="index"></el-option>
        </el-select>
        <span class="p10">筛选分类</span>
        <el-cascader size="small" v-if="formSearch.type>0 && categoryData.length>0" v-model="categoryVal" clearable :options="categoryData" :props="propsParam" @change="changeCategory"></el-cascader>
      </div>
      <el-transfer
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入关键字"
        :titles="['源题库', '已选中']"
        :left-default-checked="leftDefault"
        :right-default-checked="rightDefault"
        target-order="push"
        v-model="indexs"
        :data="list">

        <!-- <div slot="left-footer">
          <span class="mr10">搜索：</span>
          <el-select v-model="formSearch.type" clearable placeholder="请选择类型" @change="changeType" style="width:120px" v-if="formSearch.type != 60">
            <el-option :label="item.name" :value="item.key_name" v-for="(item, index) in typeData" :key="index"></el-option>
          </el-select>
          <el-cascader size="small" v-if="formSearch.type>0 && categoryData.length>0" v-model="categoryVal" clearable :options="categoryData" :props="propsParam" @change="changeCategory"></el-cascader>
        </div> -->

        <!-- <el-button class="transfer-footer" slot="left-footer" size="small">操作</el-button> -->
        <div slot="right-footer" class="d-s-c d-r">
          <el-button class="transfer-footer"  size="small" type="primary" @click="onSave">保存</el-button>
          <span class="ml10 gray9">注：按加入的顺序排序</span>
        </div>
        
      </el-transfer>
    </div>
  </el-dialog>
</template>

<script>
import QuestionLibraryApi from '@/api/study/question_library.js';
import CategoryApi from '@/api/study/category.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*是否显示*/
      dialogVisible: false,
      // formSearch: {
      //   type: '',
      //   category_ids: '',
      //   search: ''
      // },
      indexs: [],
      list: [],
      typeData: [],
      categoryData: [],
      leftDefault: [],
      rightDefault: [],
      /*展示数据*/
      propsParam: {
        label: 'name',
        value: 'category_id',
        checkStrictly: true
      },
      categoryVal: [],
      ids: [],
      is_first: true,
    }
  },
  props: ['open_quest', 'selectModel', 'formSearch'],
  created() {
    this.dialogVisible = this.open_quest;
    if (this.formSearch.type == 60){
      this.getCategoryList();
    }else{
      this.getData();
    }
  },
  methods: {
    /*取权限*/
    getQsIds(){
        let self = this;
        CategoryApi.getQsIds({type: self.selectModel.type, category_id: self.selectModel.category_id}, true).then(res => {
            if (res.code == 1) {
                self.ids = res.data;
                self.indexs = self.id2index(self.list, res.data);
            }
        });
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    id2index(list, ids){
      let arr = [];
      list.forEach((v, i) => {
        if(ids.indexOf(v.id) > -1){
          arr.push(i);
        }
      })
      return arr;
    },
    /*保存*/
    onSave(){
      let self = this;
      let ids = [];
      self.indexs.forEach(i => {
        ids.push(self.list[i].id);
      })
      if (ids.length<=0) return;
      // 保存
      self.$emit('callBackFun', {ids:ids});
      self.$emit('closeDialog', {
        type: 'success',
        openDialog: false
      });
    },
    /*获取列表*/
    getData() {
      let self = this;
      let params = self.formSearch;
      params.is_page = 0;
      QuestionLibraryApi.getList(params, true)
        .then(res => {
          if (res.code == 1) {
            self.loading = false;

            // 填充列表数据
            let list = [];
            res.data.list.forEach((v, i)=>{
              list.push({
                key: i,
                id: v.question_id,
                label: `${v.question_id}、${v.question}`,
                disabled: false
              });
            });
            self.list = list;
            self.typeData = res.data.type;
            // 默认选中
            if (self.is_first){
              self.is_first = false;
              self.getQsIds();
            }
            // self.indexs = self.id2index(list, self.selectModel.question_ids);
          }
        })
        .catch(error => {});
    },
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      });
    },
    /*选择类型*/
    changeType(){
      this.getCategoryList();
    },
    /*选择分类*/
    changeCategory(e) {
      if (this.categoryVal.length > 0) {
        this.formSearch.category_ids = this.categoryVal
      }
      this.getData();
    },
    /*获取分类列表*/
    getCategoryList() {
      let self = this;
      let Params = self.formSearch;
      self.formSearch.category_ids = '';
      self.categoryData = [];
      self.categoryVal = [];
      CategoryApi.getList(Params, true)
        .then(res => {
          self.loading = false;
          self.categoryData = res.data.list;
          self.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }

}
</script>

<style>
  .el-transfer .el-transfer-panel {
    width: 400px!important;
    height: 480px!important;
  }
  .el-transfer-panel__list.is-filterable {
    height: 35vh!important;
  }
  .el-transfer__buttons {
    padding: 0 10px!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/study/Question.vue